import React from 'react';
import { View, Platform } from 'react-native';
import { useSelector } from 'react-redux';
import IconInput from '../../../components/IconInput/IconInput';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';
import WebDatePickerInput from 'src/components/WebDatePickerInput/WebDatePickerInput';
import dateIcon from 'src/assets/date.png';
import { styles } from '../screens/Policy/PolicyScreen.styles';
import { formatDate, toDate } from 'src/helpers/dateHelper';
import { RootState } from 'src/store/store';

interface DatePickerSectionProps {
  datePicker: {
    selectedDate: Date;
    setSelectedDate: (date: Date) => void;
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
  };
}

const DatePickerSection: React.FC<DatePickerSectionProps> = ({ datePicker }) => {
  const { selectedDate, setSelectedDate, isOpen, setOpen } = datePicker;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const maxDate = new Date();
  maxDate.setDate(today.getDate() + 364);
  maxDate.setHours(23, 59, 59, 999);

  const isWeb = Platform.OS === 'web';
  const accountType = useSelector((state: RootState) => state.UI.accountType);
  const isProducerWeb = isWeb && accountType === 'producer';

  const handlePolicyDateChange = (iso: string | null) => {
    if (!iso) return; // Do nothing if null
    const parsedDate = toDate(iso);
    if (parsedDate) {
      // Clamp the date within [today, maxDate]
      const clampedDate = new Date(
        Math.min(Math.max(parsedDate.getTime(), today.getTime()), maxDate.getTime()),
      );
      setSelectedDate(clampedDate);
    }
  };

  return (
    <View style={styles.field}>
      {isProducerWeb ? (
        <>
          <View>
            <WebDatePickerInput
              testID={'policy-start-date'}
              label="When would you like your policy to start?"
              valueISO={formatDate(selectedDate, 'YYYY-MM-DD')}
              onChangeISO={handlePolicyDateChange}
            />
          </View>
        </>
      ) : (
        <>
          <IconInput
            label="When would you like your policy to start?"
            value={formatDate(selectedDate)}
            placeholder="Please select the date"
            iconSource={dateIcon}
            iconWidth={20}
            iconHeight={20}
            onPress={() => setOpen(true)}
            onIconPress={() => setOpen(true)}
          />
          <CustomDatePicker
            customHeader="Date of policy start"
            value={toDate(formatDate(selectedDate, 'YYYY-MM-DD'))}
            minDate={today}
            maxDate={maxDate}
            isOpen={isOpen}
            onSelect={(date) => {
              setSelectedDate(date);
              setOpen(false);
            }}
            onCancel={() => setOpen(false)}
          />
        </>
      )}
    </View>
  );
};

export default DatePickerSection;
